import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { message } from 'antd'
import { InboxOutlined } from '@ant-design/icons'

const PdfDropzone = ({ file, setFile }) => {
  const validateFile = (file) => {
    if (file.type !== 'application/pdf') {
      message.error('Only PDF files are allowed')
      return false
    }
    if (file.size > 5 * 1024 * 1024) {
      message.error('PDF must be less than 5MB')
      return false
    }
    return true
  }

  const onDrop = useCallback(
    (acceptedFiles) => {
      const pdf = acceptedFiles[0]
      if (pdf && validateFile(pdf)) {
        setFile(pdf)
      }
    },
    [setFile]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: { 'application/pdf': ['.pdf'] }
  })

  return (
    <div
      {...getRootProps()}
      style={{
        border: '2px dashed #1890ff',
        padding: '20px',
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '6px',
        background: '#fafafa',
        minHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <input {...getInputProps()} />

      <InboxOutlined style={{ fontSize: '32px', color: '#1890ff' }} />

      {isDragActive ? (
        <p>Drop the PDF here...</p>
      ) : (
        <p>Drag & drop PDF certificate here, or click to upload</p>
      )}

      {file && (
        <iframe
          src={URL.createObjectURL(file)}
          title="PDF Preview"
          style={{
            width: '100%',
            height: '400px',
            marginTop: '5px',
            border: '1px solid #ddd'
          }}
        />
      )}
    </div>
  )
}

export default PdfDropzone
